import React, { useState, useEffect } from 'react';
import { FaArrowsAlt } from 'react-icons/fa';
import * as cornerstone from 'cornerstone-core';
import * as cornerstoneTools from 'cornerstone-tools';
import { ControlsContainer, IconButton } from './styles';

const PanImageControls = ({ imageElement, onPanChange, isPanning }) => {
  const [isActive, setIsActive] = useState(false);

  // Reset pan tool when image element changes or isPanning changes
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (imageElement && !isPanning && isActive) {
      setIsActive(false);
      try {
        cornerstoneTools.setToolPassiveForElement(imageElement, 'Pan');
        cornerstone.updateImage(imageElement);
      } catch (error) {
        console.error('Error resetting pan tool:', error);
      }
    }
  }, [imageElement, isPanning]);

  const handlePanClick = () => {
    if (!imageElement) {
      console.error('Image element not available');
      return;
    }

    try {
      const newIsActive = !isActive;
      setIsActive(newIsActive);
      onPanChange(newIsActive);

      if (newIsActive) {
        console.log('Ativando ferramenta Pan');
        // Ensure the pan tool is added to the element
        const toolData = cornerstoneTools.getToolForElement(imageElement, 'Pan');
        if (!toolData) {
          console.log('Adicionando ferramenta Pan ao elemento');
          cornerstoneTools.addToolForElement(imageElement, cornerstoneTools.PanTool);
        }
        // Activate the pan tool with left mouse button
        cornerstoneTools.setToolActiveForElement(imageElement, 'Pan', { mouseButtonMask: 1 });
        console.log('Pan ativado:', cornerstoneTools.isToolActiveForElement(imageElement, 'Pan'));
      } else {
        console.log('Desativando ferramenta Pan');
        // Set tool to passive state when deactivated
        cornerstoneTools.setToolPassiveForElement(imageElement, 'Pan');
      }

      // Force image update to reflect changes
      cornerstone.updateImage(imageElement);
    } catch (error) {
      console.error('Erro ao alternar ferramenta Pan:', error);
      setIsActive(false);
      onPanChange(false);
    }
  };

  return (
    <ControlsContainer>
      <IconButton onClick={handlePanClick} active={isPanning} title="Mover imagem">
        <FaArrowsAlt />
      </IconButton>
    </ControlsContainer>
  );
};

export default PanImageControls;
